module.exports = __webpack_public_path__ + "static/media/image.0f1d2ff1.png";